import fetch from './http'

let baseURL = '';
if (process.env.NODE_PM === 'prod') {
    baseURL = 'https://app.aigupiao.com';
} else if (process.env.NODE_PM === 'dev') {
    baseURL = 'https://appdev.aigupiao.com';
} else if (process.env.NODE_PM === 'beta') {
    baseURL = 'https://appbeta.aigupiao.com';
}

// 邀请返现账户信息接口
export const account = args => fetch({
    url: baseURL + '/v1/affiliate/refer/account',
    method: 'get',
    params: args.params,
    headers: {
        'Authorization': 'Bearer ' + args.token
    }
});

// 用户邀请记录接口
export const records = args => fetch({
    url: baseURL +  '/v1/affiliate/refer/records',
    method: 'get',
    params: args.params,
    headers: {
        'Authorization': 'Bearer ' + args.token
    }
});

// 日志接口
export const recordLog = params => fetch({
    url: baseURL +  '/v1/affiliate/refer/log',
    method: 'post',
    data: params
});
